import { render, staticRenderFns } from "./FuerzaTooltip.vue?vue&type=template&id=ebc4a76c&scoped=true&"
import script from "./FuerzaTooltip.vue?vue&type=script&lang=js&"
export * from "./FuerzaTooltip.vue?vue&type=script&lang=js&"
import style0 from "./FuerzaTooltip.vue?vue&type=style&index=0&id=ebc4a76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc4a76c",
  null
  
)

export default component.exports